/* @ngInject */
const contactFields = (
  contactLabels,
  types,
  icons
) => {
  const self = {}

  self.id = {
    ref: 'id',
    label: contactLabels.fields.id.text,
    icon: icons.id,
    output: false,
  }

  self.lastname = {
    ref: 'lastname',
    label: contactLabels.fields.lastname.text,
    icon: icons.contact.lastname,
    type: types.text(),
    required: true,
    messages: {},
    output: false,
  }

  self.firstname = {
    ref: 'firstname',
    label: contactLabels.fields.firstname.text,
    icon: icons.contact.firstname,
    type: types.text(),
    messages: {},
    output: false,
  }

  self.function = {
    ref: 'function',
    label: contactLabels.fields.function.text,
    icon: icons.contact.function,
    type: types.text(),
    messages: {},
    output: false,
  }

  self.comment = {
    ref: 'comment',
    label: contactLabels.fields.comment.text,
    icon: icons.contact.comment,
    type: types.textarea,
    messages: {},
    output: false,
  }

  self.email = {
    ref: 'email',
    label: contactLabels.fields.email.text,
    icon: icons.contact.email,
    type: types.email,
    messages: {},
    output: false,
  }

  return self
}
export default contactFields



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/contact/resources/fields.resource.js